import axios from 'axios';

/**
 * Make a GET request to dashboard API with base URL and auth token (same pattern as existing views).
 * @param {string} baseApi - Base API URL (e.g. process.env.VUE_APP_APIENDPOINT)
 * @param {string} accessToken - Bearer token
 * @param {string} path - API path (e.g. '/dashboard/crm/realtime-kpi')
 * @param {object} params - Query params
 * @returns {Promise}
 */
export function dashboardGet(baseApi, accessToken, path, params = {}) {
  const url = `${baseApi}${path}`;
  return axios.get(url, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

export async function makeDashboardApiRequest(path, params = {}) {
  const baseApi = process.env.VUE_APP_APIENDPOINT;
  const accessToken = localStorage.getItem('accessToken'); // Get token from localStorage

  if (!baseApi || !accessToken) {
    // Return a structured error response that matches the expected format
    return { status: false, message: 'API endpoint or access token not configured.' };
  }

  try {
    const response = await dashboardGet(baseApi, accessToken, path, params);
    return response.data; // Return the data part of the response
  } catch (error) {
    console.error('API request failed:', error);
    // Standardize error response
    return { status: false, message: error.response?.data?.message || error.message || 'An unexpected error occurred' };
  }
}
